import { useRootSelector } from '../../../../../../../store/hooks';
import { selectArticleHome } from '../../../../../../../store/features/articles/home';
import { selectAudienceHubOptions } from '../../../../store/features/options';

import { RelatedProducts } from '../RelatedProducts';
import { Button } from '../../../../../shared/Button';
import { RelatedArticleCard } from '../RelatedProducts/RelatedArticleCard';
import { RelatedEventCard } from '../RelatedProducts/RelatedEventCard';

import styles from './ArticleFooter.module.scss';

export default function ArticleFooter() {
  const {
    data: {
      communityPath: audiencePath,
      relatedArticles = [],
      relatedTopics = [],
      showMoreRelatedArticlesLink,
      featuredEvent,
      showMoreEventsLink,
    },
  } = useRootSelector(selectArticleHome);
  const {
    data: { brandUrlSuffix: brandPath },
  } = useRootSelector(selectAudienceHubOptions);
  const pathPrefix = [brandPath, audiencePath];

  return (
    <div className={styles.wrapper}>
      {relatedArticles.length > 0 && (
        <RelatedProducts
          heading="Related Articles"
          products={relatedArticles}
          keyName="articleId"
          showMoreCTA={
            showMoreRelatedArticlesLink && (
              <Button
                to="/articles"
                query={{ topics: relatedTopics }}
                pathPrefix={pathPrefix}
                fullWidth
              >
                View all related articles
              </Button>
            )
          }
        >
          {(article) => (
            <RelatedArticleCard
              article={article}
              size={relatedArticles.length === 1 ? 'large' : 'small'}
            />
          )}
        </RelatedProducts>
      )}
      {featuredEvent && (
        <RelatedProducts
          heading="Related Event"
          products={[featuredEvent]}
          keyName="eventId"
          showMoreCTA={
            showMoreEventsLink && (
              <Button to="/events" pathPrefix={pathPrefix} fullWidth>
                View all upcoming events
              </Button>
            )
          }
        >
          {(event) => <RelatedEventCard event={event} />}
        </RelatedProducts>
      )}
    </div>
  );
}
